import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FiltroSelectOption } from '../filtro-select/filtro-select.component';

@Component({
  selector: 'app-filtro-select-busca',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './filtro-select-busca.component.html',
  styleUrl: './filtro-select-busca.component.scss',
})
export class FiltroSelectBuscaComponent {
  @Input() value: any = 0;
  @Input() options: FiltroSelectOption[] = [];
  @Input() placeholder = 'Selecionar';
  @Input() placeholderBusca = 'Buscar...';

  @Output() valueChange = new EventEmitter<any>();

  aberto = false;
  termoBusca = '';

  constructor(private readonly elementRef: ElementRef) {}

  get temSelecao(): boolean {
    return this.options.some((o) => o.value === this.value);
  }

  get rotuloSelecionado(): string {
    return this.options.find((o) => o.value === this.value)?.label ?? this.placeholder;
  }

  get opcoesFiltradas(): FiltroSelectOption[] {
    const termo = this.normalizar(this.termoBusca);
    if (!termo) return this.options;
    return this.options.filter((o) => this.normalizar(o.label).includes(termo));
  }

  private normalizar(texto: string): string {
    return (texto ?? '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  toggle(): void {
    this.aberto = !this.aberto;
    if (this.aberto) this.termoBusca = '';
  }

  selecionar(option: FiltroSelectOption): void {
    this.value = option.value;
    this.aberto = false;
    this.termoBusca = '';
    this.valueChange.emit(option.value);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.aberto && !this.elementRef.nativeElement.contains(event.target)) {
      this.aberto = false;
    }
  }
}
